import { onMounted, onUnmounted } from 'vue'

export function useCheckNewVersion() {
  // Durée d'inactivité après laquelle on vérifie la version (30 minutes)
  const INACTIVITY_TIMEOUT = 30 * 60 * 1000

  let lastActivityTime = Date.now()

  /**
   * Met à jour le timestamp de la dernière activité utilisateur
   */
  const updateLastActivityTime = () => {
    lastActivityTime = Date.now()
  }

  /**
   * Gère le changement de visibilité de la page
   * Vérifie la version lorsque l'utilisateur revient sur l'onglet après une période d'inactivité
   */
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      const currentTime = Date.now()
      if (currentTime - lastActivityTime > INACTIVITY_TIMEOUT) {
        checkVersionAndReloadIfNecessary()
      }
      lastActivityTime = currentTime
    }
  }

  /**
   * Configure les écouteurs d'événements pour suivre l'activité utilisateur
   * et détecter les retours sur l'onglet
   */
  function setupVersionCheck() {
    // Initialiser le timestamp
    lastActivityTime = Date.now()

    // Ajouter les écouteurs d'événements
    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('click', updateLastActivityTime)
    window.addEventListener('keypress', updateLastActivityTime)

    // Fonction pour nettoyer les écouteurs d'événements
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('click', updateLastActivityTime)
      window.removeEventListener('keypress', updateLastActivityTime)
    }
  }

  /**
   * Vérifie si une nouvelle version est disponible et recharge la page si nécessaire
   */
  async function checkVersionAndReloadIfNecessary() {
    const response = await fetch('/api/version')
    if (response.ok) {
      const { data: version } = await response.json()

      if (!version) {
        // eslint-disable-next-line no-console
        console.error('Failed to extract version from config')
        return
      }
      const currentVersion = localStorage.getItem('currentVersion')

      if (currentVersion !== version) {
        localStorage.setItem('currentVersion', version)
        // Forcer le rechargement sans utiliser le cache du navigateur
        window.location.href = window.location.href.split('?')[0] + '?t=' + new Date().getTime()
      }
    } else {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch version config')
    }
  }

  onMounted(() => {
    const cleanup = setupVersionCheck()
    onUnmounted(cleanup)
  })
}
